// Statut « site actif » de la liste Communautés — dérivé de `last_load_at`, servi par
// `GET /website?admin=admin` : dernier chargement RÉEL du widget (ThreadStat / YakliStat côté
// API, cf. DOCS/24 § ThreadStat). Jamais l'URL déclarée (fiches créées par des lecteurs),
// jamais les compteurs StatCount (un import WP remplit `comments` sans aucun chargement).
//
// Quatre états, jamais deux : « jamais chargé » (`null`) n'est pas « inactif » — le premier n'a
// jamais installé le tag, le second l'a retiré ou son site est mort. Et `undefined` (champ
// ABSENT de la réponse) n'est ni l'un ni l'autre : c'est une API qui ne sert pas encore
// `last_load_at` (super-admin sur `master`, API sur `dev` — ordre de déploiement libre). Le
// fondre dans « jamais chargé » afficherait un écran faux sur toutes les lignes et rendrait une
// recette `data-state="never"` verte contre l'ancienne API. Fonction pure, testée dans
// `src/tests/websiteActivity.test.js` (règle D30 : pas d'outil de test de rendu dans ce repo).

export const ACTIVE_WINDOW_DAYS = 30;

const DAY_MS = 24 * 60 * 60 * 1000;

export function websiteActivity(lastLoadAt, now = new Date()) {
  if (lastLoadAt === undefined) {
    return { state: 'unknown', days: null, label: '—' };
  }
  if (lastLoadAt === null || lastLoadAt === '') {
    return { state: 'never', days: null, label: 'Jamais chargé' };
  }
  const t = new Date(lastLoadAt).getTime();
  if (!Number.isFinite(t)) {
    return { state: 'never', days: null, label: 'Jamais chargé' };
  }
  const days = Math.max(0, Math.floor((now.getTime() - t) / DAY_MS));
  if (days <= ACTIVE_WINDOW_DAYS) {
    return {
      state: 'active',
      days,
      label: days === 0 ? 'Actif · aujourd’hui' : `Actif · il y a ${days} j`
    };
  }
  return { state: 'inactive', days, label: `Inactif · ${days} j` };
}
